import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter);


const TopMenu = () => import('@/components/TopMenu');
const Home = () => import('@/views/Home');
const CompetitionIntroduction = () => import('@/views/CompetitionIntroduction');
const FileDownload = () => import('@/views/FileDownload');
const Register = () => import('@/views/Register');
const Login = () => import('@/views/Login');
const TeamMenu = () => import('@/views/TeamMenu');
const Userinfo = () => import('@/views/Userinfo');
const Upload = () => import('@/views/Upload');
const Apply = () => import('@/views/Apply');
const Score = () => import('@/views/Score');
const News = () => import('@/views/News');
const Platform = () => import('@/views/Platform');
const menuMod = () => import('@/views/menu/index');
const Leaflet = () => import('@/views/Leaflet');


const routers = [{
        path: '/',
        redirect: '/pc/home',
    },
    {
        name: 'PC',
        path: '/pc',
        component: TopMenu,
        redirect: '/pc/home',
        meta: {},
        children: [{
            name: 'Home',
            path: '/pc/home',
            component: Home,
        }, {
            name: 'Cintroduction',
            path: '/pc/cintroduction',
            component: CompetitionIntroduction,
        }, {
            name: 'FDownload',
            path: '/pc/fileDownload',
            component: FileDownload,
        }, {
            name: 'menuMod',
            path: '/pc/menuMod',
            component: menuMod,
            redirect: '/pc/register',
            children: [{
                name: 'Register',
                path: '/pc/register',
                component: Register,
            }, {
                name: 'Login',
                path: '/pc/login',
                component: Login,
            }, {
                name: 'Teammenu',
                path: '/pc/menu',
                component: TeamMenu,
            }, {
                name: 'Userinfo',
                path: '/pc/userinfo',
                component: Userinfo,
            }, {
                name: 'Upload',
                path: '/pc/upload',
                component: Upload,
            }, {
                name: 'Apply',
                path: '/pc/apply',
                component: Apply,
            }, {
                name: 'Score',
                path: '/pc/score',
                component: Score,
            }]
        }, {
            name: 'News',
            path: '/pc/news',
            component: News,
        }, {
            name: 'Platform',
            path: '/pc/platform',
            component: Platform,
        }]
    },
    {
        name: 'Leaflet',
        path: '/leaflet',
        component: Leaflet,
    }
];

//添加路由对象
const router = new VueRouter({
    scrollBehavior: () => ({ y: 0 }),
    routes: routers
});



export default router